import {createAction} from '@reduxjs/toolkit'

const name = 'APP'

export const changeVisibility = createAction<boolean>(`${name}/changeVisibility`)
export const changeIdle = createAction<boolean>(`${name}/changeIdle`)
